import React from "react";


const LayoutLoading = () => {
    return (
        <div className="absolute top-0 right-0 bottom-0 left-0  bg-black bg-opacity-30 z-[1000] flex items-center justify-center"/>
    )
}

export default LayoutLoading